import { render, staticRenderFns } from "./simple-keyboard.vue?vue&type=template&id=1b8c45ad&scoped=true"
import script from "./simple-keyboard.vue?vue&type=script&lang=js"
export * from "./simple-keyboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c45ad",
  null
  
)

export default component.exports